import { render, staticRenderFns } from "./Expanded.vue?vue&type=template&id=6644b550&scoped=true&lang=pug&"
import script from "./Expanded.vue?vue&type=script&lang=js&"
export * from "./Expanded.vue?vue&type=script&lang=js&"
import style0 from "./Expanded.vue?vue&type=style&index=0&id=6644b550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6644b550",
  null
  
)

export default component.exports